import create from 'zustand';

const useMapStore = create((set) => ({
  mapRef: null,
  setMapRef: (map) => set({ mapRef: map }),
}));

export default useMapStore;
